import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { DBImportType, DBImportPreview } from '@/types/import';
import { EndpointResponse } from '@/types/endpoints';
import { utils } from '@/utils';
import type { WriteRequestOptions } from '../requestOptions';

const validate = (importType: string, token: string) => {
  if (!importType) {
    throw new Error('`importType` is required');
  }
  if (!token) {
    throw new Error('`token` is required');
  }
};

type RequestParams = {
  importType: DBImportType;
  token: string;
  skip_rows: number;
};

type Response = DBImportPreview;

export const reparseImportPreview = async (
  scope: RequestScope,
  { importType, token, skip_rows }: RequestParams,
  requestOptions: WriteRequestOptions
): Promise<EndpointResponse<Response>> => {
  try {
    validate(importType, token);

    const result = await scopedApi(scope).post<EndpointResponse<Response>>(
      `import_preview/${importType}/${token}/reparse`,
      { skip_rows },
      requestOptions
    );
    return result.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
